import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import createMutationsSharer from "vuex-shared-mutations";

import spinner from '@/store/modules/spinner';
import loginmodal from '@/store/modules/loginmodal';
import signupmodal from '@/store/modules/signupmodal';
import snackbar from '@/store/modules/snackbar';
import introsection from '@/store/modules/introsection';

// location
import location from '@/store/modules/location/index';

// cart
import cart from '@/store/modules/cart';

// search product
import searchproduct from '@/store/modules/searchproduct';

// fav product
import favouriteproducts from '@/store/modules/user/favouriteProducts';
import favouritestores from '@/store/modules/user/favouriteStores';

// Email verification
import emailverification from '@/store/modules/user/emailverification';

// Set password
import setpassword from '@/store/modules/user/setpassword';

// Checkout
import checkout from '@/store/modules/checkout';

// Orders
import orderhistory from '@/store/modules/orderhistory';

 // store profile record
 import storeprofile from '@/store/modules/storeprofile';

 // business profile
 import businessprofile from '@/store/modules/businessprofile';

// user out of stock subscribed notification
import outofstocksubscriptions from '@/store/modules/user/outofstocksubscriptions';
import userloyalitysubscription from '@/store/modules/user/loyalitysubscription';

// import brand from '@/store/modules/brand';
import fiska from '@/store/modules/fiska';


const onlySingStoreActive = (store) => {
  // called when the store is initialized
  store.subscribe((mutation, state) => {
    // locaiton data changed
    let invalidFor = ['GuestLog', 'user-login', 'signup-authneticate', 'email-verify', 'verify-age', 'register', 'stores', 'privacy-policy', 'support', 'faqs', 'terms-conditions'];
    let routePass = true;
    for (let i = 0; i < invalidFor.length; i++) {
      if ( window.location.pathname.indexOf(invalidFor[i]) > -1 ) {
        routePass = false;
        break;
      }
    }
    // console.log(routePass)
    if( routePass && (mutation.type == 'location/selectedMutate') && (state.visitor.ageVerify) ) {
      if(state.location.selected && state.location.selected.slug) {
        
        // check this slug is preset in url if no replace with shop
        let siteurl = window.location.protocol + "//" + window.location.host ;
        let pathname = window.location.pathname;
        let expPath = pathname.split('/');
        if( expPath[1] && (expPath[2] == undefined) ) {
          // do not reload if we have business url
          // console.log(expPath[1])
          // console.log(state.businessprofile.detail.slug)
          if( (state.page_load_url != window.location.href) ) {
            // console.log('if')
            // console.log(expPath[1])
            // console.log(state.businessprofile.detail.slug)
            // console.log(state.page_load_url)
            // console.log(siteurl + pathname)
            // console.log(window.location.href)
            // console.log('reload now')
            window.location.href = state.page_load_url;
          }
        } else if( (pathname.indexOf(state.location.selected.slug) == -1) 
         // && 
          //expPath[1] !== undefined 
          // expPath[2] !== undefined 
          // (expPath[2] !== 'user')  
          ) {
          //  console.log('else')
          // expPath[2] = state.location.selected.slug;
          let loadUrl = state.page_load_url;
          let pathOnly = loadUrl.split('?');
          if( (pathOnly[0] != siteurl + pathname) ) {
            // alert(state.page_load_url + ' --  '  + siteurl + pathname)
            window.location.href = state.page_load_url;
          } 
            
          // 
          // reset cart at this case
          // console.log('disapatch')
          // store.dispatch('cart/setCartItems', []);
          
        } 
      } 
    }
    // called after every mutation.
    // The mutation comes in the format of `{ type, payload }`.
  })
}


const initialState = {
    spinner: spinner.state,
    snackbar: snackbar.state,
    loginmodal: loginmodal.state,
    signupmodal: signupmodal.state,
    introsection: introsection.state,
    // location: location.state,
    cart: cart.state,
    searchproduct: searchproduct.state,
    favouriteproducts: favouriteproducts.state,
    favouritestores: favouritestores.state,
    emailverification: emailverification.state,
    setpassword: setpassword.state,
    checkout: checkout.state,
    orderhistory: orderhistory.state,
    storeprofile: storeprofile.state,
    outofstocksubscriptions: outofstocksubscriptions.state,
    // brand: brand.state,
    userloyalitysubscription: userloyalitysubscription.state,
    fiska: fiska.state,
};

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
      spinner,
      snackbar,
      loginmodal,
      signupmodal,
      introsection,
      location,
      cart,
      searchproduct,
      favouriteproducts,
      favouritestores,
      emailverification,
      setpassword,
      checkout,
      orderhistory,
      storeprofile,
      businessprofile,
      outofstocksubscriptions,
      // brand,
      userloyalitysubscription,
      fiska
    },
    plugins: [
      onlySingStoreActive,
      createPersistedState(),
      createMutationsSharer({
        predicate: [
          'USER_TOKEN',
          'USER_DETAILS',
          'CLEAR_APP_DATA',
          'location/selectedMutate',
          'userloyalitysubscription/objMutate',
          'cart/loyalityPointsObjMutate',
          'cart/cartDetailMutate',
          'cart/setCartItemsMutate',
          'cart/greenLinePosMutate',
          'MUTATE_PAGE_LOAD_URL',
        ]
      }),
    ],
    state: {
      in_store: false,
      page_load_url: '',
      landingRoute: '',
      currentRoute: {},
      visitor: {
          ageVerify: false,
          dob: false,
          province: '',
          remember: false,
      },
      loggedin: {
        token: '',
        date: '',
        user: {
            id: '',
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            _id: '',
            status: '',
            marketing_notification: '',
            email_notification: '',
        },
        login_redirect: {}, // lets pass url
      }
    },
    mutations: {
      CLEAR_APP_DATA(state) {
          /**
           * Clear all modules values while logout
           */
          Object.keys(state).forEach((key) => {
              Object.assign(state[key], initialState[key]);
          });
          state.landingRoute = '';
          state.loggedin = {
              token: '',
              date: '',
              user: {
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                id: '',
                _id: '',
                status: '',
                notification_preferences: {},
                marketing_notification: '',
                email_notification: '',
              },
              login_redirect: {},
          }
      },
      USER_TOKEN(state, data) {
          state.loggedin.token = data;
      },
      USER_DETAILS(state, data) {
          state.loggedin.user = data;
      },
      MUTATE_USER_LOGGEDIN_DATE(state, data) {
        state.loggedin.date = data;
      },
      MUTATE_USER_DETAILS_BY_KEY(state, { key , value}) {
        state.loggedin.user[key] = value;
      },
      MUTATE_USER_DETAILS_BY_KEYS(state, obj) {
        for(let key in obj){
          if(state.loggedin.user.hasOwnProperty(key)){
            state.loggedin.user[key] = obj[key];
          }
        }
      },
      USER_LOGIN_REDIRECT(state, data) {
        state.loggedin.login_redirect = data;
      },
      VISITOR_DETAILS(state, data) {
          state.visitor = data;
      },
      MUTATE_LANDING_ROUTE(state, data) {
        state.landingRoute = data;
      },
      MUTATE_CURRENT_ROUTE(state, route) {
        state.currentRoute = route;
      },
      MUTATE_IN_STORE(state, data) {
        state.in_store = data;
      },
      MUTATE_PAGE_LOAD_URL(state, data) {
        state.page_load_url = data;
      }
      
    },
    actions: {
      REMOVE_APP_DATA({ commit }) {
          commit('CLEAR_APP_DATA');
      },
      SET_USER_TOKEN({ commit }, data) {
          commit('USER_TOKEN', data);
      },
      SET_USER_DETAILS({ commit }, data) {
          commit('USER_DETAILS', data);
      },
      SET_USER_LOGGEDIN_DATE({ commit }, data) {
          commit('MUTATE_USER_LOGGEDIN_DATE', data);
      },
      SET_USER_LOGIN_REDIRECT({ commit }, data) {
          commit('USER_LOGIN_REDIRECT', data);
      },
      SET_VISITOR_DETAILS({ commit }, data) {
          commit('VISITOR_DETAILS', data);
      },
      SET_LANDING_ROUTE({ commit }, data) {
        commit('MUTATE_LANDING_ROUTE', data);
      },
    },
    getters: {
        getLoggedInUserToken(state) {
          return state.loggedin.token;
        },
        getLoggedInUserDate(state) {
          return state.loggedin.date;
        },
        getLoggedInUser(state) {
          return state.loggedin.user;
        },
        getLoggedInUserId(state) {
            if (state.loggedin.user) {
                return state.loggedin.user.id;
            }
            return null;
        },
        getLoggedInUserRedirect(state) {
          return state.loggedin.login_redirect;
        },
        getVisitorDetails(state) {
            return state.visitor;
        },
        // getProvince(state) {
        //     return state.province;
        // },
        getLandingRoute(state) {
          return state.landingRoute;
        },
        getCurrentRoute(state, getters, rootState) {
          return rootState.currentRoute;
        },
        getInStore(state) {
          return state.in_store;
        },
        getPageLoadUrl(state) {
          return state.page_load_url;
        },
    },
})

